<template>
  <v-row class="justify-space-between">
    <v-col cols="12" class="px-0">
      <v-data-table
        class="mt-4 relative-position"
        :headers="headers"
        :items="items"
        :items-per-page="pagination.itemsPerPage"
        hide-default-footer
        hide-default-header
        item-key="key"
      >
        <template v-slot:[`header`]='{ props }'>
          <table-header
            :header='props.headers'
            :selectAll='selectAll'
            @clickHeaderItem='v => {$emit("clickHeaderItem", v)}'
            @changeSelectAll='v => {$emit("changeSelectAll", v)}'
          />
        </template>
        <template v-slot:no-results>
          <p class="text-h5 mt-16">No data available</p>
        </template>
        <template v-slot:[`item.selected`]="{ item }">
          <v-simple-checkbox
            v-if='$getRight("locationDelete") && $getRight("locationEdit")'
            v-model="item.selected"
            color="#7972c0"
            :ripple="false"
          ></v-simple-checkbox>
        </template>
        <template v-slot:[`item.name`]='{ item }'>
          <span v-html='haveSearchText(item.name)'></span>
        </template>
        <template v-slot:[`item.code`]='{ item }'>
          <span v-html='haveSearchText(item.code)'></span>
        </template>
        <template v-slot:[`item.createdAt`]='{ item }'>
          <span>{{ item.createdAt | formatDate(dateTimeFormat) }}</span>
        </template>
        <template v-slot:[`item.updatedAt`]='{ item }'>
          <span>{{ item.updatedAt | formatDate(dateTimeFormat) }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row class="flex-nowrap">
            <v-col cols="4" class="px-1" v-if='$getRight("locationEdit")'>
              <img
                class="mr-1 cursor-point"
                style="height: 16px; width: 16px"
                src="@/assets/icons/svg/draw.svg"
                @click.stop="routeToEdit(item)"
                title="Edit"
              />
            </v-col>
            <v-col cols="4" class="px-1" v-if='$getRight("locationDelete")'>
              <img
                style="height: 16px; width: 16px"
                src="@/assets/icons/svg/delete1.svg"
                class="cursor-point"
                @click.stop="$emit('deleteItem', item)"
                title="Delete"
              />
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import tableHeader from './locationsTableHeader'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'locationsTable',
  components: {
    tableHeader
  },
  props: {
    headers: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    selectAll: {
      type: Boolean,
      required: true
    },
    pagination: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('user', {
      format: 'getDateTimeFormat'
    }),
    sortBy() {
      if (this.options.field) return [this.options.field]
      return []
    },
    sortDesc() {
      if (this.options.order) return this.options.order === 'desc' ? [true] : [false]
      return []
    }
  },
  filters: {
    formatDate(v, format) {
      return moment(v).format(format)
    }
  },
  methods: {
    ...mapActions(['showUpgradeSubscriptionPlanPopup']),
    haveSearchText(text) {
      const searchField = this.getSearchField
      const findedIndex = text.indexOf(searchField)
      if (findedIndex >= 0) {
        return text.replace(searchField, `<b>${searchField}</b>`)
      }
      return text
    },
    routeToEdit(item) {
      // this.$router.push({ name: 'LocationEdit', params: { id: item.id } })
    }
  }
}
</script>

<style scoped>

</style>
